import { useTranslation } from "react-i18next";
import { WifiHigh, House, Percent, CalendarCheck, WhatsappLogo, Laptop } from "@phosphor-icons/react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactSection } from "@/components/ContactSection";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/lib/api";

export default function LongStay() {
  const { t } = useTranslation();

  const features = [
    { icon: WifiHigh, title: t("longstay.f1t"), desc: t("longstay.f1d") },
    { icon: House, title: t("longstay.f2t"), desc: t("longstay.f2d") },
    { icon: Percent, title: t("longstay.f3t"), desc: t("longstay.f3d") },
    { icon: CalendarCheck, title: t("longstay.f4t"), desc: t("longstay.f4d") },
  ];

  return (
    <div className="min-h-screen bg-sand text-ink">
      <Navbar />
      <section data-testid="longstay-hero" className="bg-ink text-sand pt-32 pb-20 md:pt-44 md:pb-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 md:flex items-end justify-between gap-12">
          <Reveal className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.35em] text-terracotta mb-4 flex items-center gap-2">
              <Laptop size={16} /> {t("longstay.kicker")}
            </p>
            <h1 className="font-serif text-4xl md:text-6xl leading-[1.05]">{t("longstay.title")}</h1>
            <p className="mt-6 text-sand/70 font-light text-base md:text-lg leading-relaxed">{t("longstay.sub")}</p>
          </Reveal>
          <Reveal delay={0.1} className="shrink-0">
            <a
              data-testid="longstay-whatsapp-btn"
              href={waLink(t("remote.waMsg"))}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 md:mt-0 inline-flex items-center gap-2 px-8 py-4 bg-[#25D366] text-white text-xs uppercase tracking-[0.2em] hover:bg-[#1da851] transition-colors"
            >
              <WhatsappLogo size={16} weight="fill" /> WhatsApp
            </a>
          </Reveal>
        </div>
      </section>

      <section data-testid="longstay-features" className="py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
          {features.map((f, i) => (
            <div key={i} data-testid={`longstay-feature-${i}`} className="bg-sand p-8 md:p-10">
              <f.icon size={26} className="text-terracotta" />
              <h2 className="mt-5 font-serif text-xl text-ink">{f.title}</h2>
              <p className="mt-3 text-sm text-ink/60 font-light leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
        <p data-testid="longstay-note" className="max-w-[1400px] mx-auto px-6 md:px-10 mt-10 text-xs uppercase tracking-[0.2em] text-ink/45">
          {t("longstay.note")}
        </p>
      </section>

      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
